import * as React from 'react';
import { useIntl } from '@grandvisionhq/state';

const Measurement = ({ image , label , measurement  })=>{
    const { getLabel  } = useIntl();
    const metric = getLabel('products.measurements.metric');
    return /*#__PURE__*/ React.createElement("section", {
        className: "product-detail-frame-measurements__item"
    }, /*#__PURE__*/ React.createElement("span", {
        className: "product-detail-frame-measurements__label"
    }, getLabel(label)), /*#__PURE__*/ React.createElement("img", {
        "aria-hidden": "true",
        src: image,
        alt: ""
    }), /*#__PURE__*/ React.createElement("span", {
        className: "product-detail-frame-measurements__details"
    }, measurement, " ", metric));
};

export { Measurement };
//# sourceMappingURL=Measurement.js.map
